export default function delay(timeMs: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, timeMs));
}

export async function timeout(milliseconds: number): Promise<any> {
    await delay(milliseconds);
    throw new Error('Timeout.');
}
